import './footer.css';

const Footer = () => {
    return(
        <footer>
            <p>© 2024 Copyright: Dev.Francielly</p>
        </footer>
    )
}

export default Footer